import * as React from 'react';
import {Share,  Button, View, Text, StyleSheet, Dimensions } from 'react-native';
import { themePattern } from '../../constants/pattern';
import BtnFlatColor from '../buttons/BtnFlatColor';
import * as WebBrowser from 'expo-web-browser';



const sharedWhatsapp:any = "https://api.whatsapp.com/send?text=Disco de Aminoácidos - Experimente a mídia agora mesmo, na versão web https://eic.ifsc.usp.br/app/disco-de-aminoacidos/ ou baixe o app https://play.google.com/store/apps/details?id=com.eic.usp.DiscoAminoacidos";

const { width, height } = Dimensions.get('window')

export default function follow() {
    // Função Referencia
    let openShare = async () => {
        try {
          const result = await Share.share({
            message: 'Disco de Aminoácidos - Experimente a mídia agora mesmo, na versão web https://eic.ifsc.usp.br/app/disco-de-aminoacidos/ ou baixe o app https://play.google.com/store/apps/details?id=com.eic.usp.DiscoAminoacidos',
          });
          if (result.action === Share.sharedAction) {
            if (result.activityType) {
              // shared with activity type of result.activityType
            } else {
              // shared
            }
          } else if (result.action === Share.dismissedAction) {
            // dismissed
          }
        } catch (error) {
        }
      };

    let openWhatsapp = () => {
        WebBrowser.openBrowserAsync(sharedWhatsapp)
    };

    return (
        <View style={styles.Main}>
            <View style={styles.containerText}>
                <Text style={styles.text}>Compartilhe o <Text style={styles.destaque}>Disco de Aminoácidos</Text> em suas mídias sociais</Text>
            </View>

            <View style={styles.icons}>
                <BtnFlatColor color='#565656' icon={'share-alt'} key={20} onPress={openShare} />
                <BtnFlatColor color='#189D0E' icon={'whatsapp'} key={21} onPress={openWhatsapp} />
            </View>

        </View>

    );
}


function Styles() {

    //Mobile
    if (themePattern.breakpoint.mobile >= width)
        return StyleSheet.create({
            Main: {
                padding: 15,
                textAlign: 'center',
                alignContent: 'center',
                justifyContent: 'space-evenly',
                flex: 1
            },
            icons: {
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'space-evenly'


            }, containerText: {
                flex: 2,

                flexDirection: 'column',
                justifyContent: 'center'



            },
            text: {
                fontSize: themePattern.mobile.title3,
                textAlign: 'center'
            },
            destaque: {
                color: themePattern.mobile.color1,
                fontWeight: 'bold'


            }
        });

    //Tablet
    else
        return StyleSheet.create({
            Main: {
                padding: 15,
                textAlign: 'center',
                alignContent: 'center',
                justifyContent: 'space-evenly',
                flex: 1
            },
            icons: {
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'space-around'


            }, containerText: {
                flex: 2,

                flexDirection: 'column',
                justifyContent: 'center'



            },
            text: {
                fontSize: themePattern.tablet.title2,
                textAlign: 'center'
            },
            destaque: {
                color: themePattern.tablet.color1,
                fontWeight: 'bold'


            }
        });
}

const styles = Styles()
